import React from "react";
import Header from "../../Header/Header";
import Footer from "../../LandingPage/Footer";
import TermsAndCondition from "../TermsAndConditions";
import { Helmet } from "react-helmet-async";

const TermsAndConditionRoute = ({ setCouponCode }) => {
    return (
        <div>
            <Helmet>
                <title>Terms And Conditions | Programming Pathshala</title>
                <meta
                    name="description"
                    content="Read Terms And Conditions of Programming Pathshala."
                />
                <link rel="canonical" href="https://renaissance.programmingpathshala.com/terms-and-conditions"/>
            </Helmet>
            <div className="header-sticky">
                <Header setCouponCode={setCouponCode}/>
            </div>
            <div>
                <TermsAndCondition />
            </div>
            <div>
                <Footer />
            </div>
        </div>
    );
};

export default TermsAndConditionRoute;
